import type { ComponentPropsWithRef } from 'react'

import classNames from 'classnames'

import { AnchoredHeading } from './AnchoredHeading/AnchoredHeading'
import { generateFallbackId } from './AnchoredHeading/generateFallbackId'

type H4Props = Omit<ComponentPropsWithRef<'h4'>, 'children'> & {
  children: React.ReactNode
}

export const H4: React.FC<H4Props> = ({ className, children, ...props }) => {
  const headingId = props.id ?? generateFallbackId(children)

  if (typeof children !== 'string') {
    return (
      <h4
        className={classNames('type-h-title-md pt-5', className)}
        id={headingId}
        {...props}
      >
        {children}
      </h4>
    )
  }

  return (
    <div className="pt-5">
      <AnchoredHeading headingId={headingId}>
        <h4
          className={classNames('type-h-title-md', className)}
          id={headingId}
          {...props}
        >
          {children}
        </h4>
      </AnchoredHeading>
    </div>
  )
}
